import React, { Children } from 'react';
import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

var HTML = function HTML(_ref) {
  var children = _ref.children,
      _ref$as = _ref.as,
      tagName = _ref$as === void 0 ? 'div' : _ref$as,
      className = _ref.className,
      hook = _ref.hook,
      testId = _ref.testId,
      role = _ref.role;
  var html = children ? {
    dangerouslySetInnerHTML: {
      __html: Children.toArray(children).join('')
    }
  } : {};
  var dataHook = hook === undefined ? {} : {
    'data-hook': hook
  };
  var dataRole = role === undefined ? {} : {
    'data-role': role
  };
  var dataTestId = testId === undefined ? {} : {
    'data-testid': testId
  };

  var allProps = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
    className: className
  }, dataHook), html), dataTestId), dataRole);

  return /*#__PURE__*/React.createElement(tagName, _objectSpread2({}, allProps));
};

var _excluded = ["children"];
var Script = function Script(props) {
  var _props$children = props.children,
      children = _props$children === void 0 ? '' : _props$children,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement("script", _extends({
    dangerouslySetInnerHTML: {
      __html: children
    }
  }, rest));
};

export { HTML, Script };
